import { CompanySettings } from "../settings/CompanySettings";
import { ValueDisplayValue } from "../ValueDisplayValue";
import { Unit } from "./Unit";

export class UnitGroup {
    private _allowedUnitAbbreviations = new Set<string>();
    private _unitsByAbbreviation = new Map<string, Unit>();
    private _companyDefaultUnit: Unit;
    private _companyFunctionalUnit: Unit;

    constructor(units: Unit[], companyDefaultUnitSetting: string, companyFunctionalUnitSetting: string) {
        this.fillUnitsByAbbreviation(units);
        this.fillAllowedUnitAbbreviations();
        this.fillCompanyDefaultUnit(companyDefaultUnitSetting);
        this.fillFunctionalUnit(companyFunctionalUnitSetting);
    }

    public get unitsByAbbreviation(): Map<string, Unit> {
        return this._unitsByAbbreviation;
    }

    private fillUnitsByAbbreviation(units: Unit[]) {
        (units ?? []).forEach(unit => this.unitsByAbbreviation.set(unit.abbreviation, unit));
    }

    public get allowedUnitAbbreviations(): Set<string> {
        return this._allowedUnitAbbreviations;
    }

    private fillAllowedUnitAbbreviations() {
        for (const abbreviation of this.unitsByAbbreviation.keys()) {
            this.allowedUnitAbbreviations.add(abbreviation);
        }
    }

    public get companyDefaultUnit(): Unit {
        return this._companyDefaultUnit;
    }

    private fillCompanyDefaultUnit(companyDefaultUnitSetting: string) {
        const companyDefaultUnitAbbreviation = CompanySettings.get()[companyDefaultUnitSetting];
        this._companyDefaultUnit = this.unitsByAbbreviation.get(companyDefaultUnitAbbreviation);
    }

    public get companyFunctionalUnit(): Unit {
        return this._companyFunctionalUnit;
    }

    private fillFunctionalUnit(functionalUnitSetting: string) {
        const functionalUnitAbbreviation = CompanySettings.get()[functionalUnitSetting];
        this._companyFunctionalUnit = this.unitsByAbbreviation.get(functionalUnitAbbreviation);
    }

    public getAsDropdownItems(): ValueDisplayValue[] {
        const result: ValueDisplayValue[] = [];
        this.unitsByAbbreviation.forEach((unit: Unit, abbreviation: string) => {
            result.push(new ValueDisplayValue(unit.abbreviation, unit.displayString));
        });
        return result;
    }
}
